import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';
import './estilodash.css';

export default function ListarLicencas() {
  const [licencas, setLicencas] = useState([]);
  const [busca, setBusca] = useState('');
  const [produto, setProduto] = useState('todos');
  const [status, setStatus] = useState('ativas');

  const carregar = async () => {
    const r = await api.get('/api/licencas-v2');
    setLicencas(r.data || []);
  };

  useEffect(() => { carregar().catch(console.error); }, []);

  const filtradas = useMemo(() => {
    return licencas.filter((l) => {
      const txt = busca.toLowerCase();
      const okBusca = !txt || String(l.conta || '').toLowerCase().includes(txt) || String(l.cliente_nome || '').toLowerCase().includes(txt) || String(l.nome_plano || '').toLowerCase().includes(txt);
      const okProduto = produto === 'todos' || String(l.codigo_plano || l.produto_codigo) === produto;
      const okStatus = status === 'todos' || (status === 'ativas' ? String(l.status) === '1' : String(l.status) !== '1');
      return okBusca && okProduto && okStatus;
    });
  }, [licencas, busca, produto, status]);

  const toggleStatus = async (l) => {
    await api.put(`/api/licencas-v2/${l.id}/status`, { status: String(l.status) === '1' ? '0' : '1' });
    carregar();
  };

  const remover = async (l) => {
    if (!window.confirm('Remover esta licença?')) return;
    await api.delete(`/api/licencas-v2/${l.id}`);
    carregar();
  };

  return (
    <div>
      <h2>Licenças (novo modelo)</h2>
      <div className="form-linha">
        <label>Buscar
          <input value={busca} onChange={(e) => setBusca(e.target.value)} />
        </label>
        <label>Produto
          <select value={produto} onChange={(e) => setProduto(e.target.value)}>
            <option value="todos">Todos</option>
            <option value="ea">EA</option>
            <option value="bias">Bias</option>
            <option value="ragnarok">Ragnarok</option>
          </select>
        </label>
        <label>Status
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="ativas">Ativas</option>
            <option value="inativas">Inativas</option>
            <option value="todos">Todos</option>
          </select>
        </label>
      </div>
      <table className="clientes-table">
        <thead>
          <tr>
            <th>ID</th><th>Cliente</th><th>Assinatura</th><th>Produto</th><th>Conta</th><th>Tipo</th><th>Status</th><th>Expira</th><th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {filtradas.map(l => (
            <tr key={l.id}>
              <td>{l.id}</td>
              <td>{l.cliente_nome || l.cliente_id}</td>
              <td>{l.nome_plano || '—'} ({l.tier || '—'})</td>
              <td>{l.produto_nome || l.codigo_plano || l.produto_codigo}</td>
              <td>{l.conta}</td>
              <td>{l.tipo || '—'}</td>
              <td>{String(l.status) === '1' ? 'Ativa' : 'Inativa'}</td>
              <td>{l.date_exp ? new Date(l.date_exp).toLocaleDateString('pt-BR') : '—'}</td>
              <td>
                <button type="button" onClick={() => toggleStatus(l)}>{String(l.status) === '1' ? 'Desativar' : 'Ativar'}</button>
                <button type="button" onClick={() => remover(l)}>Remover</button>
              </td>
            </tr>
          ))}
          {filtradas.length === 0 && <tr><td colSpan="9">Nenhuma licença encontrada.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
